import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { ManageMarketComponent } from '../manage-market/manage-market.component';
import { ManageCropComponent } from '../manage-crop/manage-crop.component';
import { ManageUnitComponent } from '../manage-unit/manage-unit.component';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ManageProductComponent } from '../manage-product/manage-product.component';
import { ManageSubProductComponent } from '../manage-sub-product/manage-sub-product.component';

@Component({
  selector: 'app-marketplace',
  templateUrl: './marketplace.component.html',
  styleUrls: ['./marketplace.component.scss'],
  providers: [DatePipe]
})

export class MarketplaceComponent implements OnInit {
  displayedColumns = ['position', 'Coconutname', 'Verity', 'Cultivation', 'ExpectedPrice',
    'Location', 'DateOfPublished'];
  dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selectedIndex = -1;
  marketrateform: FormGroup;
  myDateValue: Date;
  toDate: Date;
  tablearray;
  submitted = false;
  marketdata; marketdatalist; productdata; productdatalist;
  subproductdata; subproductdatalist;
  marketId;
  unitID;
  cropId;
  productId;
  subproductId;
  disable = false;
  response;
  Remark;
  cropData;
  cropDataList = [];
  unitData;
  unitDataList = [];
  subProductDataList = [];
  subProductData;
  today = new Date();
  gettedMarketId: any;
  currentD = this.datepipe.transform(this.today, 'dd/MM/yyyy hh:mm:ss');

  constructor(private router: Router,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public _userService: UserManagementService, public toastr: ToastrService,
    private datepipe: DatePipe,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    this.selectedIndex = 2
    this.tablearray = this.dataSource.filteredData

    this.marketrateform = this.fb.group({
      MarketID: ['', [Validators.required]],
      ProductTypeID: ['', [Validators.required]],
      SubProductTypeID: ['', [Validators.required]],
      cropId: ['', [Validators.required]],
      unitID: [],
      Rate: ['', [Validators.required, Validators.min(1), Validators.max(100000000)]],
      Remark: ['']
    });
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    this.getMarketData();
    this.getCropListData();
    this.getUnitDataList();

  }

  get f() { return this.marketrateform.controls; }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  showViews(index: number) {
    this.selectedIndex = index
  }

  reverseAndTimeStamp(dateString) {
    const reverse = new Date(dateString.split("-").reverse().join("-"));
    return reverse.getTime();
  }

  filterDate() {
    let fromdate = this.datepipe.transform(this.myDateValue, 'yyyy-MM-dd');
    let todate = this.datepipe.transform(this.toDate, 'yyyy-MM-dd');
    if (this.myDateValue && this.toDate) {
      const selectedMembers = this.tablearray.filter(m => {
        return this.reverseAndTimeStamp(m.fromDate) >= this.reverseAndTimeStamp(fromdate) && this.reverseAndTimeStamp(m.fromDate) <= this.reverseAndTimeStamp(todate)
      }
      );
      this.dataSource.filteredData = selectedMembers
    } else {
      this.dataSource.filteredData = this.tablearray
    }
  }


  getMarketId(marketId) {
    this.marketId = marketId

    if (this.cropId && this.marketId) {
      let body = {
        marketID: this.marketId,
        cropId: this.cropId
      }
      
    }

  }
  getUnitId(unitID) {
    this.unitID = unitID
  }

  getCropId(cropId) {
    this.cropId = cropId
    if (cropId) {
      sessionStorage.setItem('marketCropId', cropId)
      this.getProductListData(cropId)
    }

    if (cropId && this.marketId) {
      let body = {
        marketID: this.marketId,
        cropId: cropId
      }
     
    }

  }

  getMarketData() {
    this._userService.getMarketlist().subscribe(data => {
      this.marketdata = data
      this.marketdatalist = this.marketdata.result.data
    });
  }

  getCropListData() {
    this._userService.getCropList().subscribe(data => {
      this.cropData = data
      this.cropDataList = this.cropData.result.data
    });
  }

  getProductListData(cropId) {
    this._userService.getProductlist(cropId).subscribe(data => {
      this.productdata = data
      this.productdatalist = this.productdata.result.data
    });

  }
  getUnitDataList() {
    this._userService.getUnitList().subscribe(data => {
      this.unitData = data
      this.unitDataList = this.unitData.result.data
    });
  }
  getSubProductListData(ProductTypeCode) {
    this._userService.getSubProductType(ProductTypeCode).subscribe(data => {
      this.subProductData = data
      this.subProductDataList = this.subProductData.result.data
    });
  }
  manageMarket() {
    const dialogRef = this.dialog.open(ManageMarketComponent, {
      width: '60%',
      autoFocus: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getMarketData();;
    });

  }

  manageCrop() {
    const dialogRef = this.dialog.open(ManageCropComponent, {
      width: '60%',
      autoFocus: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCropListData();
    });
  }



  manageProduct() {
    const dialogRef = this.dialog.open(ManageProductComponent, {
      width: '60%',
      autoFocus: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      let marketCropId = sessionStorage.getItem('marketCropId')
      this.getProductListData(marketCropId);
    });
  }

  manageSubProduct() {
    const dialogRef = this.dialog.open(ManageSubProductComponent, {
      width: '60%',
      autoFocus: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      let marketProductId = sessionStorage.getItem('marketProductId')
      this.getSubProductListData(marketProductId);
    });
  }

  manageUnit() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.width = "60%";
    this.dialog.open(ManageUnitComponent, dialogConfig);

  }

  subprodectfilterdata; productname;

  getproductId(val) {
    this.productId = val.productTypeCode;
    this.productname = val.productType;

    if (val) {
      sessionStorage.setItem('marketProductId', val)
      this.getSubProductListData(val);
    }

    if (this.productname == "Coconut") {
      this.subprodectfilterdata = val.subProduct
    }
    else if (this.productname == "Copra") {
      this.subprodectfilterdata = val.subProduct
    }
    else if (this.productname == "Tender Coconut") {
      this.subprodectfilterdata = val.subProduct
    }
  }

  getsubproductId(subproductId) {
    this.subproductId = subproductId
  }

  isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  deleteInputStream(data) {
    return data.target.value = data.target.value.replace(/[^0-9.]/g, '');
  }

  quantity = 1;
  Rate;
  requirederror;


  onSubmit() {
    this.submitted = true
    this.spinner.show()

    var quantityval: any = 1
    this.Rate = this.marketrateform.value.Rate
    this.Remark = this.marketrateform.value.Remark

    if (this.marketrateform.valid) {

      // this.spinner.show()
      let text = confirm("Are you sure you want to publish this Market Rate ?");
      if (text == true) {
        this._userService.postMarketRate(this.marketrateform.value).subscribe(data => {
          this.response = data;

          if (data) {
            this.spinner.hide()
          }
          this.toastr.success(this.response.result.message)
        });
        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/MarketPlace']);
        });
        // this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
        // window.location.reload();
        // this.router.navigate(['/MarketPlace']);
        //   this.spinner.hide()
        // });
      } else {
        this.spinner.hide()
      }
    }
    else {
      this.spinner.hide()
      // alert("Please enter valid and mandatory field peroperly")
    }
    this.quantity = this.marketrateform.value.Quantity
    this.Rate = this.marketrateform.value.Rate
  }

  downloadCSV() {
    let fileName = 'MarketRateUpdate.csv';
    let columnNames = ["MarketName", "ProductName", "SubProductName", "Quantity", "Rate"];
    let header = columnNames.join(',');

    let csv = header;
    csv += '\r\n';
    var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    var link = document.createElement("a");
    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  listPage() {
    this.router.navigate(['/market-rate-historical-data'])
  }
}

export interface PeriodicElement {
  Coconutname: string;
  position: number;
  Verity: string;
  Cultivation: string;
  ExpectedPrice: string;
  Location: string;
  DateOfPublished: string;
}

['position', 'Coconutname', 'Verity', 'Cultivation', 'ExpectedPrice',
  'Location', 'DateOfPublished'];

const ELEMENT_DATA: PeriodicElement[] = [
  {
    position: 1, Coconutname: 'name1', Verity: "Verity1", Cultivation: 'Cultivation1', ExpectedPrice: "5000",
    Location: "Location1", DateOfPublished: "03-08-2019"
  },
  {
    position: 2, Coconutname: 'name2', Verity: "Verity2", Cultivation: 'Cultivation2', ExpectedPrice: "10,000",
    Location: "Location1", DateOfPublished: "03-08-2019"
  },
  {
    position: 3, Coconutname: 'name3', Verity: "Verity3", Cultivation: 'Cultivation3', ExpectedPrice: "11,000",
    Location: "Location1", DateOfPublished: "03-08-2019"
  },
  {
    position: 4, Coconutname: 'name4', Verity: "Verity4", Cultivation: 'Cultivation4', ExpectedPrice: "20,000",
    Location: "Location1", DateOfPublished: "03-08-2019"
  },
  {
    position: 5, Coconutname: 'name4', Verity: "Verity5", Cultivation: 'Cultivation5', ExpectedPrice: "30,000",
    Location: "Location1", DateOfPublished: "03-08-2019"
  },


];
